import { render } from "./5and30Days.vue?vue&type=template&id=22e37d88&ts=true"
import script from "./5and30Days.vue?vue&type=script&lang=ts"
export * from "./5and30Days.vue?vue&type=script&lang=ts"

import "./5and30Days.vue?vue&type=style&index=0&id=22e37d88&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__